var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 17.9997H14.9997C15.6913 17.9997 16.283 17.583 16.533 16.983L19.0497 11.108C19.1247 10.9163 19.1663 10.7163 19.1663 10.4997V8.83301C19.1663 7.91634 18.4163 7.16634 17.4997 7.16634H12.2413L13.033 3.35801L13.058 3.09134C13.058 2.74967 12.9163 2.43301 12.6913 2.20801L11.808 1.33301L6.31634 6.82467C6.01634 7.12467 5.83301 7.54134 5.83301 7.99967V16.333C5.83301 17.2497 6.58301 17.9997 7.49967 17.9997ZM7.49967 7.99967L11.1163 4.38301L9.99967 8.83301H17.4997V10.4997L14.9997 16.333H7.49967V7.99967ZM0.833008 7.99967H4.16634V17.9997H0.833008V7.99967Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.ee65932d70e41254200fab103f48b66e.svg";
export { ForwardRef as ReactComponent };